module.exports = __webpack_public_path__ + "static/la-ventures--anna-sesbreno-645c6e58051bf05ff15afa28b74d48aa.mp4";